import React from 'react';
import { Link } from 'react-router-dom';
import { Discussion } from '../types';
import ValidityBadge from './ValidityBadge';
import { formatLocalRange, formatLocalTimestamp, formatUtcRange } from '../utils/discussionTime';

interface Props {
  discussion: Discussion;
}

const DiscussionCard: React.FC<Props> = ({ discussion }) => {
  const publishedDate = formatLocalTimestamp(discussion.published_at || discussion.created_at);
  const hazardTags = discussion.hazard_tags || [];
  const validUtcRange = formatUtcRange(discussion.valid_from_utc, discussion.valid_to_utc);
  const validLocalRange = formatLocalRange(discussion.valid_from_utc, discussion.valid_to_utc);
  const probabilitySummary = [
    discussion.tornado_probability ? `Tor ${discussion.tornado_probability}` : null,
    discussion.wind_probability ? `Wind ${discussion.wind_probability}` : null,
    discussion.hail_probability ? `Hail ${discussion.hail_probability}` : null,
  ].filter(Boolean).join(' | ');

  return (
    <article className="discussion-card">
      <Link to={`/discussions/${discussion.permalink}`} className="discussion-card-link">
        <h3 className="discussion-card-title">
          {discussion.md_number ? <span className="md-number">#{discussion.md_number} </span> : null}
          {discussion.title}
        </h3>
      </Link>
      <div className="discussion-card-meta">
        <span>{discussion.published_at ? 'Published' : 'Created'} {publishedDate}</span>
        <span>{discussion.views} views</span>
        <span className={`status-pill status-${discussion.status}`}>{discussion.status}</span>
        <ValidityBadge validFromUtc={discussion.valid_from_utc} validToUtc={discussion.valid_to_utc} status={discussion.status} />
      </div>
      <div className="discussion-card-footer">
        <div className="chip-row">
          {discussion.tags.map((tag) => (
            <span key={tag} className="chip chip-static">{tag}</span>
          ))}
          {hazardTags.map((tag) => (
            <span key={tag} className="chip chip-hazard">{tag}</span>
          ))}
        </div>
      </div>
      {validUtcRange && <p className="field-help">MD valid {validUtcRange}</p>}
      {validLocalRange && <p className="field-help">Local time {validLocalRange}</p>}
      {probabilitySummary && <p className="field-help">Probabilities {probabilitySummary}</p>}
      <p className="discussion-card-content line-clamp-2">{discussion.summary || discussion.discussion_body || 'No summary available.'}</p>
    </article>
  );
};

export default DiscussionCard;
